import { render } from "./PrevPageIcon.vue?vue&type=template&id=a465f0ee"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PrevPageIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a465f0ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a465f0ee', __exports__)) {
    api.reload('a465f0ee', __exports__)
  }
  
  module.hot.accept("./PrevPageIcon.vue?vue&type=template&id=a465f0ee", () => {
    api.rerender('a465f0ee', render)
  })

}


export default __exports__